// Greenhold operating entity — the single source of truth for the company
// details both apps must display.
//
// Story 6.10 / action item 16. Danish e-commerce law (and the DK marketing
// act) requires the trader's legal name, CVR, geographic address and an
// electronic contact point to be readily available on the site. These
// values are ALSO written into the three legal documents under
// `docs/legal/` — if they change here, change them there too (and bump
// each document's version line).
//
// ApS conversion is deliberately postponed (session item C1, 2026-08-07):
// the platform launches and operates under the founder's personally owned
// company. When the conversion happens, this file and the entity block in
// all three legal documents change together.

export const LEGAL_ENTITY = {
  /** Registered legal name of the operator. */
  name: "Stagelund",
  /** Danish CVR (company registration) number. */
  cvr: "41064560",
  /** Registered geographic address — street, postcode + town. Appears in
   *  the legal documents ONLY; the site footer deliberately omits it (owner
   *  request 2026-08-15 — it is the founder's home address). */
  addressLine: "Fuglsangvej 1",
  postCode: "5464",
  town: "Brenderup",
  country: "Denmark",
  /** Electronic contact point. Also the DSAR / privacy contact. Changed from
   *  the founder's personal gmail 2026-08-15 (tos-user v1.5, privacy v1.1) —
   *  the mailbox must exist and be monitored on the greenhold.dk domain. */
  email: "stagelund@greenhold.dk",
} as const;

/** One-line address, e.g. "Fuglsangvej 1, 5464 Brenderup, Denmark". */
export const LEGAL_ENTITY_ADDRESS = `${LEGAL_ENTITY.addressLine}, ${LEGAL_ENTITY.postCode} ${LEGAL_ENTITY.town}, ${LEGAL_ENTITY.country}`;

/** Full trader identification line used in footers and legal headers. */
export const LEGAL_ENTITY_LINE = `${LEGAL_ENTITY.name} · CVR ${LEGAL_ENTITY.cvr} · ${LEGAL_ENTITY_ADDRESS}`;
